import React, { useState, useEffect } from "react";
import {
  Form
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useTranslation } from "react-i18next";
import "./index.css";

import { Creators as LastDateCorrectionActions } from "./../../store/ducks/lastDateCorrections";

const LastDateCorrectionSearch = ({
  props: { lastPositionsSearchQuery, lastPositionSelected },
  funcs: { searchLastDateCorrection }
}) => {
  const { t } = useTranslation();
  const [dateCorrectionsSearch, setDateCorrectionsSearch] = useState({
    client: lastPositionsSearchQuery.client,
    niple: lastPositionsSearchQuery.niple,
    patrimony: lastPositionSelected ? lastPositionSelected.position.patrimony.id : "",
    word: ""
  });

  useEffect(() => {
    searchLastDateCorrection(dateCorrectionsSearch);
  }, [dateCorrectionsSearch, searchLastDateCorrection]);

  useEffect(() => {
    setDateCorrectionsSearch(prevState => ({
      ...prevState,
      client: lastPositionsSearchQuery.client,
      niple: lastPositionsSearchQuery.niple,
      patrimony: lastPositionSelected ? lastPositionSelected.position.patrimony.id : ""
    }));
  }, [lastPositionsSearchQuery, lastPositionSelected]);

  return (
    <form onSubmit={e => e.preventDefault()}>
      <Form.Group controlId="date-corrections-item-form-search">
        <Form.Control
          type="text"
          placeholder={t("Placeholder.Search")}
          autoComplete={"off"}
          onChange={e => setDateCorrectionsSearch(prevState => ({
            ...prevState,
            word: e.target.value
          }))}
          value={dateCorrectionsSearch.word}
          disabled={false}
        />
      </Form.Group>
    </form>
  );
};

const mapStateToProps = state => ({
  props: {
    lastPositionsSearchQuery: state.lastPositions.positionsSearchQuery,
    lastPositionSelected: state.lastPositions.positionSelected
  }
});

const mapDispatchToProps = dispatch => ({
  funcs: bindActionCreators(Object.assign({}, LastDateCorrectionActions), dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(LastDateCorrectionSearch);
